import Vue from 'vue';

import { statuses } from '../../constants/jobRates';

export default {
	actions: {
	},
};
